module.exports = __webpack_public_path__ + "static/media/p&g.7e1efe97.png";